export const GoogleMapsAPI = 'AIzaSyD_xZbQQVruH1NWLqCE2kgSWBPoWH7l3Sw';
